import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@ui/Form";
import { QUERY_KEYS } from "@/constants/queryKeys";
import type { Tariff } from "@/types/Operator";
import { useMultiStepForm } from "@/hooks";
import { cn } from "@/utils/tailwind";
import { OperatorApi } from "@/api/OperatorApi";
import { PaginatedSelect } from "@/components/Selects";

export const TariffBillingSubform: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { t } = useTranslation();
  const { form } = useMultiStepForm();
  const operatorId = form.watch("step2.operator")?.id;

  return (
    <FormField
      control={form.control}
      name="step3.tariff"
      render={({ field }) => (
        <FormItem className="gap-1 pl-7 sm:px-7">
          <FormControl>
            <div className="space-y-0.5">
              <FormDescription className={cn(disabled && "text-input")}>
                {t("step3.q1_tariffLabel")}
              </FormDescription>
              <PaginatedSelect<Tariff>
                queryKey={[QUERY_KEYS.TARIFFS, { operatorId }]}
                fetchFn={(limit, offset) => OperatorApi.getAllTariffs(limit, offset, operatorId)}
                getOptionLabel={t => t.name}
                getOptionValue={t => t.id.toString()}
                value={field.value?.id.toString() ?? ""}
                onSelectItem={field.onChange}
                isError={Boolean(form.formState.errors.step3?.tariff)}
                triggerClassName="sm:max-w-[216px]"
                disabled={disabled}
                dataTest="tariff-select"
              />
            </div>
          </FormControl>
          <FormMessage data-test="tariff-error" />
        </FormItem>
      )}
    />
  );
};
